var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgB = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.25rem",
  height: "5.25rem",
  "data-name": "Group 6",
  viewBox: "0 0 200 215.107"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "B_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h200v215.107H0z",
  "data-name": "Rectangle 17"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5",
  style: {
    clipPath: "url(#B_svg__a)"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M99.714 0a8.98 8.98 0 0 0-6.878 3.152C82.521 15.365 69.161 26.325 56.16 36.963 28.618 59.527 0 82.808 0 118.911 0 151.648 23.065 174.5 55.874 174.5a48.44 48.44 0 0 0 22.646-6.065 4.824 4.824 0 0 1 6.82 5.8 215 215 0 0 1-13.976 33.28 5.113 5.113 0 0 0 5.147 7.5 195.5 195.5 0 0 1 47.036.047 5.113 5.113 0 0 0 5.142-7.5 217 217 0 0 1-14.016-33.321 4.824 4.824 0 0 1 6.818-5.808 48.4 48.4 0 0 0 22.635 6.06C176.9 174.5 200 151.648 200 118.911c0-36.067-28.368-59.384-55.875-81.948-13-10.638-26.647-21.562-36.963-33.811A8.92 8.92 0 0 0 100.286 0z",
  "data-name": "Path 3"
}))));
export default SvgB;